import { Link } from "react-router-dom";
import { PageBanner } from "@/shared/components/PageBanner";

/**
 * صفحه شروع دامنه «گردش‌کار (Workflow)».
 * طبق ADR-072 Rule FMS-02، بعد از generate شدن src/api/generated/workflow/**
 * با orval، هوک‌های TanStack Query همینجا مستقیم import و مصرف می‌شوند.
 */
export function WorkflowHomePage() {
  return (
    <div style={{ padding: "0.5rem 0", maxWidth: "100%", margin: "0", display: "flex", flexDirection: "column", gap: "1.5rem" }}>
      <PageBanner
        title="گردش‌کار (Workflow)"
        subtitle="مدیریت فرآیندهای تأیید و گردش اسناد سازمانی"
        icon="🔄"
        helpLink="/help/workflow/home"
      />

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
          gap: "1.5rem",
        }}
      >
        <Link
          to="/workflow/inbox"
          className="brand-card-extand block"
          style={{ padding: "1.5rem", textDecoration: "none" }}
        >
          <div style={{ fontSize: "2.2rem", marginBottom: "0.75rem" }}>
            📥
          </div>
          <h3 style={{ fontSize: "1.1rem", fontWeight: "800", color: "#007270", marginBottom: "0.5rem" }}>
            صندوق تأیید (Inbox)
          </h3>
          <p style={{ color: "var(--color-text-main)", fontSize: "0.85rem", margin: 0 }}>
            مشاهده و تأیید مواردی که به کارتابل شما ارجاع شده‌اند
          </p>
        </Link>
      </div>
    </div>
  );
}
